<template>
  <v-card v-if="visible" class="mb-4" outlined style="border-radius: 16px">
    <v-card-text>
      <v-chip small outlined color="primary">
        <app-icon left small>star</app-icon>
        1º passo para ativar sua clínica
      </v-chip>

      <h2 class="mt-4 primary--text">
        Cadastre seu primeiro {{ customerAlias }}
      </h2>

      <p class="mt-2">
        Após cadastrar um {{ customerAlias }}, você poderá utilizar todos os
        recursos inteligentes da plataforma para uma gestão completa e
        eficiente.
      </p>

      <v-row dense class="mb-2">
        <v-col cols="12" sm="6" v-for="feature in features" :key="feature.title">
          <div class="d-flex align-center feature-item pa-3">
            <v-avatar color="#EDEAFC" size="38" class="mr-3">
              <app-icon color="primary" small>{{ feature.icon }}</app-icon>
            </v-avatar>
            <span class="font-weight-medium">{{ feature.title }}</span>
          </div>
        </v-col>
      </v-row>

      <v-btn color="primary" depressed @click="$router.push('/clientes')">
        <app-icon left>add</app-icon>
        Cadastrar {{ customerAlias }}
      </v-btn>

      <FirstStepsVideo class="mt-4" />
    </v-card-text>
  </v-card>
</template>

<script>
import { customerAlias } from "@/utils/customerAlias";
import { smartFeatures } from "@/components/dashboard/data/smartFeatures";
import { withinOnboardingWindow } from "@/utils/onboardingWindow";
import FirstStepsVideo from "@/components/app/sections/FirstStepsVideo.vue";

export default {
  components: {
    FirstStepsVideo,
  },

  data() {
    return {
      features: smartFeatures,
    };
  },

  computed: {
    customerAlias() {
      return customerAlias();
    },

    company() {
      return this.$store.state.auth.company;
    },

    hasCustomer() {
      return this.$store.state.onboarding.hasCustomer;
    },

    visible() {
      return !this.hasCustomer && withinOnboardingWindow(this.company);
    },
  },
};
</script>

<style scoped>
.feature-item {
  border: 1px solid #eeebf6;
  border-radius: 12px;
}
</style>
